import firestore, { storage } from './firebaseConfig';
import moment from 'moment';

const PAGE_SIZE = 10

const postsRef = firestore.collection('posts')
const imagesRef = storage.ref('images')

export function addImage (image, key) {
    return imagesRef.child(key).put(image).then(snapshot => {
        return snapshot.ref.getDownloadURL()
    })
}

export function getPost(id) {
    return postsRef.doc(id).get().then(snapshot => {
        return {
            id,
            ...snapshot.data(),
        }
    })
}

export function getLatestPostsByCategory(category, pageSize=PAGE_SIZE) {
    return postsRef.where('category', '==', category)
        .orderBy('createdAt', 'desc')
        .limit(pageSize)
        .get().then(snapshot => {
            const posts = []
            snapshot.forEach(doc => {
                posts.push({
                    id: doc.id,
                    ...doc.data(),
                })
            })
            return posts
        })
}

export function getFourLatestPostsByCategory(category) {
    return postsRef.where('category', '==', category)
        .orderBy('createdAt', 'desc')
        .limit(4)
        .get().then(snapshot => {
            const posts = []
            snapshot.forEach(doc => {
                posts.push({
                    id: doc.id,
                    ...doc.data(),
                })
            })
            return posts
        })
}

export function getTenNextPostByCategory(category, time) {
    return postsRef.where('category', '==', category)
    .orderBy('createdAt', 'desc')
    .startAfter(time)
    .limit(10)
    .get().then(snapshot => {
        const posts = []
        snapshot.forEach(doc => {
            posts.push({
                id: doc.id,
                ...doc.data()
            })
        })
        return posts
    })
}

export function getSevenLatestPosts() {
    return postsRef
        .orderBy('createdAt', 'desc')
        .limit(7)
        .get().then(snapshot => {
            const posts = []
            snapshot.forEach(doc => {
                posts.push({
                    id: doc.id,
                    ...doc.data()
                })
            })
            return posts
        })

}
export function getTenLatestPosts() {
    return postsRef
        .orderBy('createdAt', 'desc')
        .limit(10)
        .get().then(snapshot => {
            const posts = []
            snapshot.forEach(doc => {
                posts.push({
                    id: doc.id,
                    ...doc.data()
                })
            })
            return posts
        })

}

export function createPost(doc) {
    const {
        category = '',
        title = '',
        body = '',
        author = '',
        image = null,
    } = doc
    const post = { 
        category, 
        title, 
        body, 
        author, 
        createdAt: moment().valueOf(),
    }

    const ref = postsRef.doc()
    return Promise.resolve().then(() => {
        if (image) {
            return addImage (image, ref.id)
        }
    }).then( imgUrl => {
        if (imgUrl) post.imgUrl = imgUrl
        return ref.set(post)
    })
}

export function editPost(id, update) {
    let image = null
    if ('image' in update) {
        image = update.image
        delete update.image
    }

    return Promise.resolve().then(() => {
        if (image) {
            return addImage (image, id)
        }
    }).then( imgUrl => {
        if (imgUrl) update.imgUrl = imgUrl
        return postsRef.doc(id).update(update)
    })
}

export function deletePost(id) {
    return postsRef.doc(id).delete()
}
